import { PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH } from "constants/index";

export function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

export function validatePass(pass) {
  return pass.length >= PASSWORD_MIN_LENGTH &&
    pass.length <= PASSWORD_MAX_LENGTH
    ? true
    : false;
}
